import React from "react";
import { BrowserRouter, Route, Link } from "react-router-dom";
import '../App.css';
import styles from "../index.css"


function Navbar() {
  return (
    <nav className="Navbar">
      <ul className="list">
        <li>
          <Link to="/">WDYM</Link>
        </li>
        <li>
          <Link to="/about">ABOUT</Link>
        </li>
      </ul>
    </nav>
  );
}




export default Navbar;
